import { IconFont } from '@fast-radius/shared-ui';
import React from 'react';

import { Modal, classNames } from 'fr-shared/components';

import { Button, Link } from 'portal/components';

import styles from './SyBridgeOnDemandModal.module.css';

const IMSection = () => {
  return (
    <div className="flex gap-1 p-1">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        width="32"
      >
        <path
          id="vector"
          d="M21 12H17.4L14.7 21L9.3 3L6.6 12H3"
          stroke="#19B3AA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
      <div>
        <h5 className="text-lg font-bold">Instant quotes for injection molding</h5>
        <p className="text-base text-coolGray-400">
          Finally, you won&apos;t have to wait for RFQs for injection molded parts
        </p>
      </div>
    </div>
  );
};

const DesignInsightsSection = () => {
  return (
    <div className="flex gap-1 p-1">
      <svg
        width="36"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.84615 10.8929C10 9.5 11 5 11 5C11 5 12.3077 9.78571 13.1538 10.8929C14 12 18 13.0357 18 13.0357C18 13.0357 14.6251 13.5839 13.1538 15C11.622 16.4744 11 20 11 20C11 20 10 16 8.84615 15C7.69231 14 4 13.0357 4 13.0357C4 13.0357 7.69231 12.2857 8.84615 10.8929Z"
          stroke="#705EF6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M16.1054 4.91196L16.6655 3.55826C16.7507 3.35238 17.0424 3.35238 17.1276 3.55826L17.6857 4.90714C17.7104 4.96673 17.7571 5.01449 17.8161 5.04043L19.4791 5.77112C19.6783 5.85867 19.6783 6.14133 19.4791 6.22888L17.8161 6.95957C17.7571 6.98552 17.7104 7.03327 17.6857 7.09286L17.1276 8.44174C17.0424 8.64762 16.7507 8.64762 16.6655 8.44174L16.1054 7.08804C16.0819 7.03133 16.0384 6.98524 15.9832 6.95854L14.4657 6.22509C14.2774 6.13409 14.2774 5.86591 14.4657 5.77491L15.9832 5.04146C16.0384 5.01476 16.0819 4.96866 16.1054 4.91196Z"
          fill="#705EF6"
        ></path>
      </svg>
      <div>
        <h5 className="text-lg font-bold">More design insights</h5>
        <p className="text-base text-coolGray-400">
          We&apos;ve redesigned Studio, now with tooling insights and more DFM checks
        </p>
      </div>
    </div>
  );
};

const MuchMoreSection = () => {
  return (
    <div className="flex gap-1 p-1">
      <svg
        width="46"
        height="24"
        viewBox="0 0 48 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.47726 33.4998C8.16523 32.9531 8.00064 32.3329 8 31.7015L8 17.2985C8.00064 16.6671 8.16523 16.0469 8.47727 15.5002C8.7893 14.9536 9.2378 14.4996 9.77778 14.1839L22.2222 6.98241C22.7627 6.66638 23.3759 6.5 24 6.5M8.47726 33.4998C8.7893 34.0464 9.2378 34.5004 9.77778 34.8161L22.2222 42.0176C22.7627 42.3336 23.3759 42.5 24 42.5C24.6241 42.5 25.2373 42.3336 25.7778 42.0176M8.47726 33.4998L16.2386 28.4999M40 17.2985C39.9994 16.6671 39.8348 16.0469 39.5227 15.5002C39.2107 14.9536 38.7622 14.4996 38.2222 14.1839L25.7778 6.98241C25.2373 6.66638 24.6241 6.5 24 6.5M24 6.5V16.5M16.2386 28.4999C16.0826 28.2569 16.0003 27.9813 16 27.7007L16 21.2993C16.0003 21.0187 16.0826 20.7431 16.2386 20.5001M16.2386 28.4999C16.3946 28.7429 16.6189 28.9446 16.8889 29.0849L23.1111 32.2856C23.3814 32.4261 23.6879 32.5 24 32.5M24 32.5C24.3121 32.5 24.6186 32.4261 24.8889 32.2856L31.1111 29.0849C31.3811 28.9446 31.6054 28.7429 31.7614 28.4999C31.9174 28.2569 31.9997 27.9813 32 27.7007V21.2993C31.9997 21.0187 31.9174 20.7431 31.7614 20.5001M24 32.5V24.5M31.7614 20.5001C31.6054 20.2571 31.3811 20.0554 31.1111 19.9151L24.8889 16.7144C24.6186 16.5739 24.3121 16.5 24 16.5M31.7614 20.5001L24 24.5M24 16.5C23.6879 16.5 23.3814 16.5739 23.1111 16.7144L16.8889 19.9151C16.6189 20.0554 16.3947 20.2571 16.2386 20.5001M16.2386 20.5001L24 24.5"
          stroke="#F98A07"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M37.5537 31.7453L39.4931 27.0583C39.5783 26.8524 39.8699 26.8524 39.9551 27.0583L41.8926 31.7405C41.9173 31.8001 41.964 31.8478 42.023 31.8738L47.4791 34.2711C47.6783 34.3587 47.6783 34.6413 47.4791 34.7289L42.023 37.1262C41.964 37.1522 41.9173 37.1999 41.8926 37.2595L39.9551 41.9417C39.8699 42.1476 39.5783 42.1476 39.4931 41.9417L37.5537 37.2547C37.5302 37.198 37.4867 37.1519 37.4315 37.1252L32.4657 34.7251C32.2774 34.6341 32.2774 34.3659 32.4657 34.2749L37.4315 31.8748C37.4867 31.8481 37.5302 31.802 37.5537 31.7453Z"
          fill="#F98A07"
        ></path>
      </svg>
      <div>
        <h5 className="text-lg font-bold">And much more</h5>
        <p className="text-base text-coolGray-400">
          Upload files in their native CAD format, create multiple carts, and experience improved
          UI/UX
        </p>
      </div>
    </div>
  );
};

const PromoSection = () => {
  return (
    <div className="gap-1 p-1">
      <div className="p-1 text-lg">
        Use <b>WELCOME10</b> at checkout for 10% off your first order on the SyBridge Digital
        Platform
      </div>
      <div className="p-1 text-lg">
        For more information,{' '}
        <Link
          to={{ pathname: 'https://sybridge.com/technologies/faq/' }}
          type="text"
          openNewWindow
        >
          visit our FAQs
        </Link>{' '}
      </div>
    </div>
  );
};

interface SybridgeOnDemandModalProps {
  isOpen?: boolean;
}

export const SyBridgeOnDemandModal = ({ isOpen }: SybridgeOnDemandModalProps) => {
  return (
    <Modal
      className={classNames([styles.Root, styles.SyBridgeOnDemandModalRoot])}
      backdrop={true}
      isOpen={isOpen}
    >
      {({ toggle }: { toggle: () => void }) => (
        <Modal.Body className="!pl-0">
          <div className={classNames([styles.ModalContent, 'pt-6 px-6 p-3'])}>
            <div className="p-3 border-solid border-coolGray-600 border-b border-t-0 border-x-0 items-start">
              <h3 className="text-center">This Portal is Going Away</h3>
              <p className="text-lg text-center">
                Now that Fast Radius is part of SyBridge, we&apos;ve designed a brand new
                experience that combines both companies&apos; capabilities.
              </p>
            </div>
            <Button
              dataTestId="modal-close"
              onClick={() => toggle()}
              className={classNames([styles.ModalClose, 'modal-close'])}
              size="md"
            >
              <IconFont name="close" />
            </Button>

            <div className="flex p-1">
              <div className="flex- flex-col pt-1">
                <IMSection />

                <DesignInsightsSection />

                <MuchMoreSection />

                <PromoSection />
              </div>
            </div>

            <div className="pb-3 pt-2 justify-center flex items-baseline mt-auto">
              <Button
                color="secondary"
                type="link"
                className={classNames(['w-[168px] btn-lg'])}
                to={{ pathname: 'https://app.sybridge.com' }}
                openNewWindowWithReferrer
              >
                {' '}
                Try Now
              </Button>
            </div>
          </div>
        </Modal.Body>
      )}
    </Modal>
  );
};

export default SyBridgeOnDemandModal;
